/* tslint:disable */
/* eslint-disable */
/**
 * PR TIMES プレスリリースエディタ API
 * PR TIMES 企業管理画面 プレスリリースエディタ用の API
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    PressReleaseMediaList,
    PressReleaseMediaListFromJSON,
    PressReleaseMediaListFromJSONTyped,
    PressReleaseMediaListToJSON,
} from './PressReleaseMediaList';

/**
 * GET /media_list/imported
 * @export
 * @interface GetPressReleaseMediaListImportedResponse
 */
export interface GetPressReleaseMediaListImportedResponse {
    /**
     * 
     * @type {number}
     * @memberof GetPressReleaseMediaListImportedResponse
     */
    status: number;
    /**
     * 
     * @type {string}
     * @memberof GetPressReleaseMediaListImportedResponse
     */
    message: string;
    /**
     * 
     * @type {Array<PressReleaseMediaList>}
     * @memberof GetPressReleaseMediaListImportedResponse
     */
    data: Array<PressReleaseMediaList>;
}

export function GetPressReleaseMediaListImportedResponseFromJSON(json: any): GetPressReleaseMediaListImportedResponse {
    return GetPressReleaseMediaListImportedResponseFromJSONTyped(json, false);
}

export function GetPressReleaseMediaListImportedResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetPressReleaseMediaListImportedResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'status': json['status'],
        'message': json['message'],
        'data': ((json['data'] as Array<any>).map(PressReleaseMediaListFromJSON)),
    };
}

export function GetPressReleaseMediaListImportedResponseToJSON(value?: GetPressReleaseMediaListImportedResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'status': value.status,
        'message': value.message,
        'data': ((value.data as Array<any>).map(PressReleaseMediaListToJSON)),
    };
}

